import React from 'react';
import './InfoBox.scss';

interface InfoBoxProps {
    info: string | number | JSX.Element;
    subtitle?: any;
}
export const InfoBox: React.FC<InfoBoxProps> = (props) => {
    const { info, subtitle } = props;

    return (
        <div tabIndex={0} className="info-box">
            <h5 className="heading-small-light info">{info}</h5>
            <p className="body-xs-bold info-subtitle">{subtitle}</p>
        </div>
    );
};
